import React from 'react'

import ProtectedComponent from '../../../generic/ProtectedComponent'
import MainContent from '../../MainContent'
import ConfigGroupsPageHeader from './ConfigGroupsPageHeader'
import { Box } from '../../../generic/Box'
import GroupsTable from './GroupsTable'
import CreateGroupModal from './CreateGroupModal'
import EditGroupModal from './EditGroupModal'

const ConfigGroupsPage = props => {
  return (
    <ProtectedComponent permission='configure_groups'>
      <MainContent>
        <Box>
          <ConfigGroupsPageHeader />
          <GroupsTable />
        </Box>
      </MainContent>
      <CreateGroupModal />
      <EditGroupModal />
    </ProtectedComponent>
  )
}

export default ConfigGroupsPage



// WEBPACK FOOTER //
// ./src/components/dashboard/config/groups/ConfigGroupsPage.js